/**
 * Auto-generated version information
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated from git tags by scripts/generate-version.js
 */

export const APP_VERSION = 'v25.10.0';
export const VERSION_CODENAME = 'Barberry';

/**
 * Get formatted version string
 * Format: Codename (vYY.MM.patch)
 * Example: Apricot (v24.12.1)
 */
export function getFormattedVersion() {
  if (VERSION_CODENAME) {
    return `${VERSION_CODENAME} (${APP_VERSION})`;
  }
  return APP_VERSION;
}
